import { STM } from '../context/types';

export const es_esStatements : STM[]  = [ 
  {
    "id":1,
    "title":"el trabajo en equipo es frecuente",
    "title_360_leadership": "estimula el trabajo en equipo",
    "title_360_workenv": "el trabajo en equipo es frecuente",
    "preferredType": "leadership"
  },
  {
    "id":2,
    "title":"los intereses del equipo tienen prioridad sobre los intereses individuales",
    "title_360_leadership": "antepone el éxito del equipo al suyo propio",
    "title_360_workenv": "los intereses del equipo tienen prioridad sobre los intereses individuales",
    "preferredType": "workenv"
  },
  {
    "id":3,
    "title":"se hace lo mejor para el equipo",
    "title_360_leadership": "se implica por su equipo",
    "title_360_workenv": "se hace lo mejor para el equipo",
    "preferredType": "leadership"
  },
  {
    "id":4,
    "title":"no se comparte una opinión personal si puede provocar un conflicto",
    "title_360_leadership": "no expresa su opinión si ello puede dar lugar a un conflicto",
    "title_360_workenv": "no se comparte una opinión personal si puede provocar un conflicto",
    "preferredType": "workenv"
  },
  {
    "id":5,
    "title":"hay que esforzarse todo lo posible para mantener la paz",
    "title_360_leadership": "hace todo lo posible por evitar discusiones",
    "title_360_workenv": "hay que esforzarse todo lo posible para mantener la paz",
    "preferredType": "leadership"
  },
  {
    "id":6,
    "title":"hay que cumplir estrictamente con las normas y reglas existentes",
    "title_360_leadership": "garantiza el respeto de las reglas y normas",
    "title_360_workenv": "hay que cumplir estrictamente con las normas y reglas existentes",
    "preferredType": "workenv"
  },
  {
    "id":7,
    "title":"los compañeros y gerentes respetan la gente",
    "title_360_leadership": "garantiza un ambiente de respeto mutuo",
    "title_360_workenv": "los compañeros y gerentes respetan la gente",
    "preferredType": "workenv"
  },
  {
    "id":8,
    "title":"se da reconocimiento al trabajo duro",
    "title_360_leadership": "nos da reconocimiento por lo que hacemos",
    "title_360_workenv": "se da reconocimiento al trabajo duro",
    "preferredType": "workenv"
  },
  {
    "id":9,
    "title":"el compromiso es valorado y apreciado",
    "title_360_leadership": "recompensa el esfuerzo realizado",
    "title_360_workenv": "el compromiso es valorado y apreciado",
    "preferredType": "leadership"
  },
  {
    "id":10,
    "title":"siempre hay que hacer lo correcto para los demás",
    "title_360_leadership": "es atento y respetuoso",
    "title_360_workenv": "siempre hay que hacer lo correcto para los demás",
    "preferredType": "leadership"
  },
  {
    "id":11,
    "title":"hay que contribuir al bienestar de los demás",
    "title_360_leadership": "fomenta un ambiente en el que todos se sienten bien",
    "title_360_workenv": "hay que contribuir al bienestar de los demás",
    "preferredType": "workenv"
  },
  {
    "id":12,
    "title":"la gente se ayuda uno a otro", 
    "title_360_leadership": "fomenta un clima de ayuda mutua",
    "title_360_workenv": "la gente se ayuda uno a otro",
    "preferredType": "leadership"
  },
  {
    "id":13,
    "title":"se trata igualmente a todos",
    "title_360_leadership": "trata a todos con equidad",
    "title_360_workenv": "se trata igualmente a todos",
    "preferredType": "workenv"
  },
  {
    "id":14,
    "title":"la edad, el origen, o el sexo no tienen importancia",
    "title_360_leadership": "no discrimina por edad, origen o sexo",
    "title_360_workenv": "la edad, el origen, o el sexo no tienen importancia",
    "preferredType": "workenv"
  },
  {
    "id":15,
    "title":"la gente se juzga por sus acciones y no por su carácter",
    "title_360_leadership": "nos evalúa en función de nuestras acciones, no de nuestro carácter",
    "title_360_workenv": "la gente se juzga por sus acciones y no por su carácter",
    "preferredType": "leadership"
  },
  {
    "id":16,
    "title":"la mayoría de las veces es posible actuar autónomamente",
    "title_360_leadership": "significa que cada individuo determina en gran medida lo que hace",
    "title_360_workenv": "la mayoría de las veces es posible actuar autónomamente",
    "preferredType": "workenv"
  },
  {
    "id":17,
    "title":"se puede decidir individualmente el método propio de trabajo",
    "title_360_leadership": "nos permite determinar nuestra propia forma de trabajar",
    "title_360_workenv": "se puede decidir individualmente el método propio de trabajo",
    "preferredType": "leadership"
  },
  {
    "id":18,
    "title":"se puede planificar individualmente cómo hacer su trabajo",
    "title_360_leadership": "permite a cada cual determinar en gran medida su propio horario",
    "title_360_workenv": "se puede planificar individualmente cómo hacer su trabajo",
    "preferredType": "workenv"
  },
  {
    "id":19,
    "title":"puedo influir el comportamiento de los demás",
    "title_360_leadership": "influye en mi trabajo",
    "preferredType": "leadership"
  },
  {
    "id":20,
    "title":"yo soy quien decide lo que hay que hacer", // je suis celui/celle qui décide ce qui doit être fait
    "title_360_leadership": "dice lo que hay que hacer",
    "preferredType": "leadership"
  },
  {
    "id":21,
    "title":"yo decido lo que va a pasar", //je décide ce qui se passe
    "title_360_leadership": "determina lo que se debe hacer",
    "preferredType": "disabled"
  },
  {
    "id":22,
    "title":"hay estructura y regularidad",
    "title_360_leadership": "garantiza estructura y regularidad",
    "title_360_workenv": "hay estructura y regularidad",
    "preferredType": "workenv"
  },
  {
    "id":23,
    "title":"las cosas suceden como se han planeado",
    "title_360_leadership": "garantiza que, en general, las cosas salgan según lo previsto",
    "title_360_workenv": "en general, las cosas salen según lo previsto",
    "preferredType": "leadership"
  },
  {
    "id":24,
    "title":"se pueden conservar los valores tradicionales y los modos de pensar",
    // on peut garder les valeurs traditionnelles et les façons de penser
    "title_360_leadership": "garantiza el respeto de los valores y el pensamiento tradicionales",
    "title_360_workenv": "conservas tus valores tradicionales y tu forma de pensar",
    "preferredType": "workenv"

  },
  {
    "id":25,
    "title":"es posible dar lo mejor de uno mismo",
    "title_360_leadership": "nos anima a dar lo mejor de nosotros mismos",
    "title_360_workenv": "puede sacar lo mejor de sí mismo",
    "preferredType": "leadership"
  },
  {
    "id":26,
    "title":"se puede demostrar su potencial completo",
    "title_360_leadership": "nos anima a demostrar lo que podemos hacer",
    "title_360_workenv": "puede demostrar su potencial",
    "preferredType": "workenv"
  },
  {
    "id":27,
    "title":"se puede sobresalir en su trabajo",
    "title_360_leadership": "le anima a destacar en lo que hace",
    "title_360_workenv": "puede destacar en lo que hace",
    "preferredType": "workenv"
  },
  {
    "id":28,
    "title":"se pueden aprender cosas nuevas continuamente",
    "title_360_leadership": "favorece la formación continua",
    "title_360_workenv": "se pueden aprender cosas nuevas continuamente",
    "preferredType": "workenv"
  },
  {
    "id":29,
    "title":"se pueden ampliar los conocimientos",
    "title_360_leadership": "nos anima a desarrollar nuestras competencias",
    "title_360_workenv": "se pueden ampliar los conocimientos",
    "preferredType": "leadership"
  },
  {
    "id":30,
    "title":"se puede ampliar continuamente el desarrollo personal",
    "title_360_leadership": "ayuda a otros a desarrollarse",
    "title_360_workenv": "se puede ampliar continuamente el desarrollo personal",
    "preferredType": "workenv"
  },
  {
    "id":31,
    "title":"se entrega trabajo de buena calidad",
    "title_360_leadership": "garantiza que el equipo realice un trabajo de alta calidad",
    "title_360_workenv": "se entrega trabajo de buena calidad",
    "preferredType": "leadership"
  },
  {
    "id":32,
    "title":"se respeta los clientes y/o otros en el negocio", //on respecte les clients et d'autres personnes
    "title_360_leadership": "anima activamente al equipo a respetar a los clientes y otras relaciones",
    "title_360_workenv": "se respeta los clientes y/o otros en el negocio",
    "preferredType": "workenv"
  },
  {
    "id":33,
    "title":"se tiene en cuenta a las personas, la seguridad y el medio ambiente",
    "title_360_leadership": "garantiza la protección de las personas, la seguridad y el medio ambiente",
    "title_360_workenv": "se tiene en cuenta a las personas, la seguridad y el medio ambiente",
    "preferredType": "workenv"
  },
  {
    "id":34,
    "title":"se asume responsabilidad por las acciones propias", //on assume la responsabilité de ce qu'on fait
    "title_360_leadership": "se asegura de que asumamos la responsabilidad de nuestros actos",
    "title_360_workenv": "se asume responsabilidad por las acciones propias",
    "preferredType": "workenv"
  },
  {
    "id":35,
    "title":"la gente es honrada",
    "title_360_leadership": "es honesto/honesta",
    "title_360_workenv": "la gente es honrada",
    "preferredType": "workenv"
  },
  {
    "id":36,
    "title":"se respeta la confidencialidad",
    "title_360_leadership": "trata con cuidado la información personal y confidencial",
    "title_360_workenv": "se respeta la confidencialidad",
    "preferredType": "leadership"
  },
  {
    "id":37,
    "title":"se pueden probar cosas nuevas",
    "title_360_leadership": "nos anima a probar nuevas formas de trabajar",
    "title_360_workenv": "se pueden probar cosas nuevas",
    "preferredType": "leadership"
  },
  {
    "id":38,
    "title":"se tiene muchas nuevas experiencias", //on peut découvrir beaucoup de nouvelles choses
    "title_360_leadership": "favorece las nuevas experiencias",
    "title_360_workenv": "se tiene muchas nuevas experiencias",
    preferredType: 'workenv',
  },
  {
    "id":39,
    "title":"se pueden buscar desafíos", //on peut trouver des défis
    "title_360_leadership": "nos estimula a buscar nuevos retos",
    "title_360_workenv": "se pueden buscar desafíos",
    "preferredType": "leadership"
  },
  {
    "id":40,
    "title":"se toma la iniciativa para abordar tareas",
    "title_360_leadership": "te anima a iniciar las tareas por ti mismo",
    "title_360_workenv": "se toma la iniciativa para abordar tareas",
    "preferredType": "workenv"
  },
  {
    "id":41,
    "title":"se da alta prioridad a hacer todo lo posible para obtener resultados", // on s'assure que les résultats sont atteints
    "title_360_leadership": "garantiza la obtención de resultados",
    "title_360_workenv": "se da alta prioridad a hacer todo lo posible para obtener resultados",
    "preferredType": "leadership"
  },
  {
    "id":42,
    "title":"se hace todo esfuerzo posible para lograr los objetivos establecidos",
    "title_360_leadership": "hace todo lo posible por alcanzar sus objetivos",
    "title_360_workenv": "se hace todo esfuerzo posible para lograr los objetivos establecidos",
    "preferredType": "leadership"
  }
]

export const extra360Es_EsStatements : Omit<STM, 'title'>[] = [
    // Additional statements used in Actual360 but not IdealClassic
    {
      id: 43,
      valueKey: 'daadkracht4',
      title_360_leadership:
          'toma decisiones',
      preferredType: 'leadership',
    },
    {
      id: 44,
      valueKey: 'gelijk4',
      title_360_leadership:
          'respeta y valora las diferencias entre los miembros del equipo',
      preferredType: 'leadership',
    },
    {
      id: 45,
      valueKey: 'prestatie4',
      title_360_leadership:
          'da opiniones constructivas',
      preferredType: 'leadership',
    },
]

